import React from "react";

const Mensaje = ({ mensaje }) => {
  return <p className="text-center alert alert-info">{mensaje}</p>;
};

export default Mensaje;
